import script from "./LoginWebRoot.vue?vue&type=script&lang=js"
export * from "./LoginWebRoot.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__